import { useCallback } from "react"
import dayjs from "dayjs"

import { useLazyGetUserProfileQuery } from "store/api/profileApi"
import { useAppDispatch } from "store/hooks"
import { setUserActiveTheme, setUserLogo } from "store/tempDataSlise"
import { setUserProfile } from "store/userSlise"
import { ApiTypes } from "types"
import { StorageKeys } from "types/enums/StorageKeys"
import SubscriptionPlan from "types/enums/SubscriptionPlan"

import { UserRole } from "utils/checkRoleType"
import { setStorageItem } from "utils/localStorage"

export const useRefreshUserProfile = () => {
  const dispatch = useAppDispatch()
  const [triggerGetProfile] = useLazyGetUserProfileQuery()

  return useCallback(async () => {
    try {
      const res = await triggerGetProfile()

      if (res && !res.error) {
        const profile = res?.data?.data
        const lastSync = dayjs()

        setStorageItem(StorageKeys.UserProfile, { ...profile, lastSync } as ApiTypes.Model.UserProfile)
        dispatch(setUserProfile(profile ? { ...profile, lastSync } : null))

        const canUseCustomTheme =
          profile?.contractor?.subscription_plan === SubscriptionPlan.E_PLUS ||
          profile?.type === UserRole.EnterpriseManager

        if (canUseCustomTheme) {
          const freshLogo = profile?.contractor?.image ?? profile?.enterprise?.image
          if (freshLogo) {
            dispatch(setUserLogo(freshLogo))
          }
        } else {
          dispatch(setUserActiveTheme("default"))
          dispatch(setUserLogo())
        }
      }
    } catch (error) {
      console.error(error)
    }
  }, [dispatch, triggerGetProfile])
}
